import { Tooltip } from 'antd';
import { getOperatorLabel } from '../core/operators';
import { type FieldType, type FilterOperator, OPERATOR_ICONS } from '../core/types';

interface OperatorBadgeProps {
    operator: FilterOperator;
    /** Field type, so the tooltip label reads naturally for dates ("is after" etc.). */
    fieldType?: FieldType;
    /** When true, hovering the badge reveals the readable operator label. */
    withTooltip?: boolean;
    className?: string;
}

/**
 * OperatorBadge
 *
 * Compact accent-coloured glyph for a filter operator (∈, ∋, =, …), reused by
 * the filter chip and the operator dropdown. Uses the theme-aware accent scale
 * (no `dark:` variants — the scale flips automatically).
 */
export function OperatorBadge({ operator, fieldType, withTooltip = false, className }: OperatorBadgeProps) {
    const badge = (
        <span
            className={`inline-flex h-5 min-w-5 items-center justify-center rounded-md border border-accent-200 bg-accent-500/10 px-1 font-mono text-accent-600 text-xs leading-none ${className ?? ''}`}
        >
            {OPERATOR_ICONS[operator]}
        </span>
    );

    if (!withTooltip) {
        return badge;
    }

    return <Tooltip title={getOperatorLabel(operator, fieldType)}>{badge}</Tooltip>;
}
